var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBookmarkFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 1.25A1.75 1.75 0 0 0 3.25 3v11a.75.75 0 0 0 1.28.53L8 11.06l3.47 3.47a.75.75 0 0 0 1.28-.53V3A1.75 1.75 0 0 0 11 1.25H5z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBookmarkFilled);
export default ForwardRef;